import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ImageNo } from "../image/ImageComponent";
import { Button, Card, Image } from "antd";
import { IoIosArrowForward, IoMdClose } from "react-icons/io";
import { RiShoppingBag3Line, RiBookOpenLine, RiContactsBookLine, RiCompass3Line } from "react-icons/ri";
import logoESI from "../../assets/images/logo.svg"

const SubmitIframeTextDragAds = ({
    fileList,
    picUrl,
    dataObject,
    AdsTab,
    activeAdSection = "splash",
    banners = [],
    popupPicUrl = "",
    popupFileList = [],
    popupSection = "all"
}) => {
    const { i18n, t } = useTranslation();
    const [previewOpen, setPreviewOpen] = useState(false);
    const [currentBannerIndex, setCurrentBannerIndex] = useState(0);

    const handlePreviewImage = async (url) => {
        if (url) {
            setPreviewOpen(url);
        }
    };

    // Splash Image extraction
    const getSplashImageUrl = () => {
        if (fileList?.[0]?.url) return fileList[0].url;
        if (fileList?.[0]?.thumbUrl) return fileList[0].thumbUrl;
        if (fileList?.[0]?.preview) return fileList[0].preview;
        if (Array.isArray(picUrl)) {
            if (typeof picUrl[0] === "string") return picUrl[0];
            if (typeof picUrl[0] === "object") return picUrl[0]?.url || "";
        }
        if (typeof picUrl === "string") return picUrl;
        if (typeof picUrl === "object" && picUrl !== null) return picUrl?.url || "";
        return "";
    };

    // Popup Image extraction
    const getPopupImageUrl = () => {
        if (popupFileList?.[0]?.url) return popupFileList[0].url;
        if (popupFileList?.[0]?.thumbUrl) return popupFileList[0].thumbUrl;
        if (popupFileList?.[0]?.preview) return popupFileList[0].preview;
        if (typeof popupPicUrl === "string" && popupPicUrl) return popupPicUrl;
        if (typeof popupPicUrl === "object" && popupPicUrl !== null) return popupPicUrl?.url || "";
        return "";
    };

    // Auto rotate banners if multiple images exist
    const bannerItems = (banners && banners.length > 0)
        ? banners
        : (dataObject?.banners && dataObject.banners.length > 0)
            ? dataObject.banners
            : [];

    useEffect(() => {
        if (activeAdSection === "banner" && bannerItems.length > 1) {
            const timer = setInterval(() => {
                setCurrentBannerIndex((prev) => (prev + 1) % bannerItems.length);
            }, 3000);
            return () => clearInterval(timer);
        }
    }, [activeAdSection, bannerItems.length]);

    // Ensure valid current banner index
    useEffect(() => {
        if (currentBannerIndex >= bannerItems.length && bannerItems.length > 0) {
            setCurrentBannerIndex(0);
        }
    }, [bannerItems.length, currentBannerIndex]);

    const splashImg = getSplashImageUrl();
    const popupImg = getPopupImageUrl();
    const hasSplashImage = !!splashImg;
    const hasPopupImage = !!popupImg;

    return (
        <>
            {previewOpen && (
                <Image
                    wrapperStyle={{ display: 'none' }}
                    preview={{
                        visible: !!previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible ? previewOpen : false),
                        afterOpenChange: (visible) => !visible && setPreviewOpen(false),
                    }}
                    src={previewOpen}
                />
            )}
            <div className="w-100 h-100 content-dynamic-main">
                <div className="w-100 content-dynamic-scrolls-ads">
                    
                    {/* ===================== MODE 1: APP SPLASH SCREEN AD ===================== */}
                    {activeAdSection === "splash" && (
                        <Card
                            style={{
                                position: "relative",
                                height: hasSplashImage ? "502px" : "454px",
                                width: hasSplashImage ? "100%" : "210px",
                                top: hasSplashImage ? "0" : "22px",
                                border: "1.5px dashed #d1d4dc",
                                margin: "auto",
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                overflow: "hidden",
                                padding: 0
                            }}
                        >
                            {hasSplashImage && (
                                <Button
                                    type="primary"
                                    size="small"
                                    style={{
                                        backgroundColor: "rgba(0, 0, 0, 0.65)",
                                        color: "#ffffff",
                                        borderRadius: "20px",
                                        position: "absolute",
                                        top: "24px",
                                        right: "16px",
                                        zIndex: 10,
                                        fontSize: "11px",
                                        padding: "0 10px",
                                        height: "24px",
                                        border: "none"
                                    }}
                                >
                                    {t("jump over")} 2s
                                </Button>
                            )}
                            {hasSplashImage ? (
                                <img
                                    onClick={() => handlePreviewImage(splashImg)}
                                    src={splashImg}
                                    alt="Splash Ad"
                                    className="image-mobile-fullScreen"
                                    style={{ cursor: "pointer", width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            ) : (
                                <div className="text-aligns-center" style={{ padding: "20px" }}>
                                    <img
                                        onClick={() => handlePreviewImage(ImageNo)}
                                        src={ImageNo}
                                        alt="No Ad"
                                        className="image-mobile-70"
                                        style={{ cursor: "pointer", width: "64px", opacity: 0.6 }}
                                    />
                                    <p className="ant-upload-text mt-2" style={{ fontSize: "12px", color: "#8c8c8c" }}>
                                        {t("Please upload an image of the splash screen ad.")}
                                    </p>
                                </div>
                            )}

                            {/* BOTTOM ACTION BUTTON */}
                            {hasSplashImage && (
                                <Button
                                    type="primary"
                                    shape="round"
                                    icon={<IoIosArrowForward />}
                                    style={{
                                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                                        backdropFilter: "blur(4px)",
                                        color: "white",
                                        position: "absolute",
                                        bottom: "28px",
                                        left: "50%",
                                        height: "36px",
                                        width: "84%",
                                        transform: "translateX(-50%)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexDirection: "row-reverse",
                                        fontSize: "12px",
                                        border: "none",
                                        cursor: AdsTab === "internal" ? "default" : "pointer"
                                    }}
                                    onClick={() => (AdsTab === "external" && dataObject?.linkUrl) && window.open(dataObject?.linkUrl, "_blank")}
                                >
                                    {t("Click to go to the details page")}
                                </Button>
                            )}
                        </Card>
                    )}

                    {/* ===================== MODE 2: HOMEPAGE ROTATING BANNER AD (BEFORE CONTACT US) ===================== */}
                    {activeAdSection === "banner" && (
                        <div
                            style={{
                                width: "100%",
                                height: "502px",
                                backgroundColor: "#F7F8FA",
                                borderRadius: "12px",
                                overflowY: "auto",
                                overflowX: "hidden",
                                position: "relative",
                                padding: "12px 10px",
                                display: "flex",
                                flexDirection: "column",
                                gap: "10px",
                                fontSize: "12px"
                            }}
                        >
                            {/* App Header simulation */}
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 4px 8px" }}>
                                <div>
                                    <img alt='ESI-Logo' src={logoESI} style={{width:"80px"}}/>
                                </div>
                                <div style={{ display: "flex", gap: "8px", color: "#9CA3AF" }}>
                                    <RiCompass3Line size={18} />
                                    <RiShoppingBag3Line size={18} />
                                </div>
                            </div>

                            {/* Top feature cards mockup */}
                            <div style={{ background: "#ffffff", padding: "10px", borderRadius: "10px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
                                <div style={{ height: "60px", background: "linear-gradient(135deg, #FF6B8B 0%, #FF8E53 100%)", borderRadius: "8px", color: "#fff", padding: "8px 12px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                    <span style={{ fontWeight: 600, fontSize: "13px" }}>{t("ESI New Season Style")}</span>
                                    <span style={{ fontSize: "10px", opacity: 0.9 }}>{t("Fashion & Art Excellence")}</span>
                                </div>
                            </div>

                            {/* Content items mockup */}
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
                                <div style={{ background: "#ffffff", padding: "8px", borderRadius: "8px", textAlign: "center" }}>
                                    <RiBookOpenLine size={20} color="#E50A47" />
                                    <div style={{ fontSize: "11px", fontWeight: 500, marginTop: "4px" }}>{t("Magazine")}</div>
                                </div>
                                <div style={{ background: "#ffffff", padding: "8px", borderRadius: "8px", textAlign: "center" }}>
                                    <RiShoppingBag3Line size={20} color="#3B82F6" />
                                    <div style={{ fontSize: "11px", fontWeight: 500, marginTop: "4px" }}>{t("Product")}</div>
                                </div>
                            </div>

                            {/* ================= ROTATING BANNER AD SECTION ================= */}
                            <div style={{ marginTop: "6px" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                                    <span style={{ fontSize: "11px", fontWeight: 600, color: "#4B5563" }}>
                                        {t("Banner Ads")} ({bannerItems.length})
                                    </span>
                                    <span style={{ fontSize: "10px", color: "#E50A47" }}>
                                        {bannerItems.length > 1 ? t("Auto Rotating") : ""}
                                    </span>
                                </div>

                                {bannerItems.length > 0 ? (
                                    <div
                                        style={{
                                            position: "relative",
                                            width: "100%",
                                            height: "115px",
                                            borderRadius: "10px",
                                            overflow: "hidden",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                                            backgroundColor: "#000"
                                        }}
                                    >
                                        <img
                                            src={bannerItems[currentBannerIndex]?.url || bannerItems[0]?.url}
                                            alt="Banner Ad"
                                            onClick={() => handlePreviewImage(bannerItems[currentBannerIndex]?.url || bannerItems[0]?.url)}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                                transition: "all 0.5s ease-in-out"
                                            }}
                                        />
                                        {/* Dot Indicators */}
                                        {bannerItems.length > 1 && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    bottom: "6px",
                                                    left: "50%",
                                                    transform: "translateX(-50%)",
                                                    display: "flex",
                                                    gap: "5px",
                                                    zIndex: 5
                                                }}
                                            >
                                                {bannerItems.map((_, idx) => (
                                                    <span
                                                        key={idx}
                                                        onClick={() => setCurrentBannerIndex(idx)}
                                                        style={{
                                                            width: currentBannerIndex === idx ? "16px" : "6px",
                                                            height: "6px",
                                                            borderRadius: "3px",
                                                            backgroundColor: currentBannerIndex === idx ? "#E50A47" : "rgba(255,255,255,0.7)",
                                                            cursor: "pointer",
                                                            transition: "all 0.3s"
                                                        }}
                                                    />
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            height: "95px",
                                            border: "1.5px dashed #d1d4dc",
                                            borderRadius: "10px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            color: "#9CA3AF",
                                            background: "#fff"
                                        }}
                                    >
                                        <span style={{ fontSize: "11px" }}>{t("Please upload an image or GIF for the banner ad.")}</span>
                                    </div>
                                )}
                            </div>

                            {/* ================= CONTACT US SECTION (RIGHT AFTER BANNER) ================= */}
                            {/* <div
                                style={{
                                    background: "#ffffff",
                                    borderRadius: "10px",
                                    padding: "10px 12px",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                                    marginTop: "4px"
                                }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: "6px", color: "#1F2937", fontWeight: 600, fontSize: "12px", marginBottom: "6px" }}>
                                    <RiContactsBookLine size={16} color="#E50A47" />
                                    <span>{t("Contact Us")}</span>
                                </div>
                                <div style={{ fontSize: "10px", color: "#6B7280", lineHeight: "1.4" }}>
                                    <div>Email: support@esi-system.com</div>
                                    <div>Hotline: +852 2345 6789</div>
                                </div>
                            </div> */}

                            <div style={{ height: "10px" }} />
                        </div>
                    )}

                    {/* ===================== MODE 3: SECTION AD POP-UP ===================== */}
                    {activeAdSection === "popup" && (
                        <div
                            style={{
                                width: "100%",
                                height: "502px",
                                backgroundColor: "#F3F4F6",
                                borderRadius: "12px",
                                overflow: "hidden",
                                position: "relative",
                                padding: "14px 10px"
                            }}
                        >
                            {/* Background Section Page Content Simulation */}
                            <div style={{ opacity: 0.4, filter: "blur(1px)", pointerEvents: "none" }}>
                                <div style={{ fontWeight: "bold", fontSize: "14px", marginBottom: "8px" }}>
                                    {Array.isArray(popupSection)
                                        ? popupSection.map(s => s === "all" ? t("All Sections") : s === "magazine" ? t("Magazine") : s === "news" ? t("News") : s === "product" ? t("Product") : s === "technology" ? t("Technique") : s === "fashion" ? t("Fashion") : s).join(", ")
                                        : t(popupSection === "magazine" ? "Magazine" : popupSection === "news" ? "News" : popupSection === "product" ? "Product" : popupSection === "technology" ? "Technique" : popupSection === "fashion" ? "Fashion" : "All Sections")}
                                </div>
                                <div style={{ height: "70px", background: "#e5e7eb", borderRadius: "8px", marginBottom: "8px" }} />
                                <div style={{ height: "70px", background: "#e5e7eb", borderRadius: "8px", marginBottom: "8px" }} />
                                <div style={{ height: "70px", background: "#e5e7eb", borderRadius: "8px" }} />
                            </div>

                            {/* Dimmed Modal Overlay */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(0, 0, 0, 0.65)",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "20px",
                                    zIndex: 20
                                }}
                            >
                                {/* Pop-up Dialog Card */}
                                <div
                                    style={{
                                        position: "relative",
                                        width: "100%",
                                        maxWidth: "230px",
                                        backgroundColor: "#ffffff",
                                        borderRadius: "14px",
                                        overflow: "hidden",
                                        boxShadow: "0 10px 25px rgba(0,0,0,0.35)",
                                        textAlign: "center"
                                    }}
                                >
                                    {/* Close Button Top Right */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "8px",
                                            right: "8px",
                                            width: "24px",
                                            height: "24px",
                                            borderRadius: "50%",
                                            backgroundColor: "rgba(0,0,0,0.4)",
                                            color: "#ffffff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            zIndex: 25
                                        }}
                                    >
                                        <IoMdClose size={16} />
                                    </div>

                                    {/* Popup Ad Graphic */}
                                    {hasPopupImage ? (
                                        <img
                                            src={popupImg}
                                            alt="Section Popup Ad"
                                            onClick={() => handlePreviewImage(popupImg)}
                                            style={{
                                                width: "100%",
                                                height: "190px",
                                                objectFit: "cover",
                                                cursor: "pointer",
                                                display: "block"
                                            }}
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                height: "160px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                padding: "16px",
                                                color: "#9CA3AF"
                                            }}
                                        >
                                            <img src={ImageNo} alt="No ad" style={{ width: "48px", opacity: 0.5, marginBottom: "8px" }} />
                                            <span style={{ fontSize: "11px" }}>{t("Please upload an image or GIF for the popup ad.")}</span>
                                        </div>
                                    )}

                                    {/* Action Button */}
                                    <div style={{ padding: "10px" }}>
                                        <Button
                                            type="primary"
                                            block
                                            style={{
                                                backgroundColor: "#E50A47",
                                                borderColor: "#E50A47",
                                                borderRadius: "8px",
                                                fontSize: "12px",
                                                height: "32px",
                                                fontWeight: 600
                                            }}
                                        >
                                            {t("Click to go to the details page")}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </>
    );
};

export default SubmitIframeTextDragAds;
